import { IconName, PalleteColor } from 'nanaykuna-ui-kit/loader';

export interface UrgencyVisual {
  iconName: IconName;
  fill: PalleteColor;
  // Background of the 28px circle the clock sits in.
  bg: 'bg-feedback-error-light' | 'bg-feedback-warning-light';
}

// Value → visual lookup for the per-row approval-deadline indicator.
// `Urgent` and `Overdue` share one entry: the same clock glyph inside a red
// circle, per the Figma design (one component, two colour overrides).
// `None` and any value the frontend does not recognise resolve to `null`,
// which the template reads as "render no icon".
export const URGENCY_VISUAL_MAP: Record<
  'Urgent' | 'DueSoon' | 'Overdue' | 'None',
  UrgencyVisual | null
> = {
  Urgent: {
    iconName: 'clock',
    fill: 'feedback-error-default',
    bg: 'bg-feedback-error-light',
  },
  Overdue: {
    iconName: 'clock',
    fill: 'feedback-error-default',
    bg: 'bg-feedback-error-light',
  },
  DueSoon: {
    iconName: 'clock',
    fill: 'feedback-warning-default',
    bg: 'bg-feedback-warning-light',
  },
  None: null,
};

// The only two urgency values the API accepts as a filter (`?urgency=`) —
// `Overdue`/`None` are display-only, never filterable. Single source of
// truth for the whitelist `sanitizeFilters` and the CA-11 banner's "Ver
// registros" shortcut each need, and for the CA-13 drawer group's labels.
export const FILTERABLE_URGENCIES = ['Urgent', 'DueSoon'] as const;

export type FilterableUrgency = (typeof FILTERABLE_URGENCIES)[number];

export function isFilterableUrgency(value: string): value is FilterableUrgency {
  return (FILTERABLE_URGENCIES as readonly string[]).includes(value);
}

// Display labels for the "Plazo de vencimiento" filter group (CA-13) — a
// separate concern from URGENCY_VISUAL_MAP above (icon/color, no text).
export const URGENCY_FILTER_LABELS: Record<FilterableUrgency, string> = {
  Urgent: 'Urgente',
  DueSoon: 'Próximo a vencer',
};
